import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Link as MuiLink,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useConsent } from "./ConsentContext";

const CookieConsent = () => {
  const {
    preferences,
    hasDecision,
    settingsOpen,
    acceptAll,
    rejectAll,
    savePreferences,
    openSettings,
    closeSettings,
  } = useConsent();
  const [draft, setDraft] = useState(preferences);

  useEffect(() => {
    if (settingsOpen) setDraft(preferences);
  }, [settingsOpen, preferences]);

  const saveDraft = () => {
    savePreferences(draft);
    closeSettings();
  };

  return (
    <>
      {!hasDecision && (
        <Box
          role="region"
          aria-label="Preferencias de cookies"
          sx={{
            position: "fixed",
            left: { xs: 12, md: 24 },
            right: { xs: 12, md: 24 },
            bottom: { xs: 12, md: 24 },
            zIndex: 1400,
            maxWidth: 980,
            mx: "auto",
            p: { xs: 2, md: 3 },
            color: "#fff",
            bgcolor: "#17171A",
            border: "1px solid rgba(255,255,255,0.18)",
            borderRadius: 3,
            boxShadow: "0 18px 50px rgba(0,0,0,0.45)",
          }}
        >
          <Typography variant="h5" component="h2" sx={{ color: "#fff", mb: 1 }}>
            Tu privacidad, tu elección
          </Typography>
          <Typography variant="body2" sx={{ color: "#D9D9DE", mb: 2 }}>
            Usamos almacenamiento necesario para recordar tu elección. Con tu
            permiso también utilizaremos Google Analytics para medir visitas y
            Google Maps para mostrar las ubicaciones. Puedes aceptar, rechazar o
            configurar cada finalidad. Consulta la{" "}
            <MuiLink
              component={RouterLink}
              to="/politica-cookies"
              sx={{ color: "#fff", textDecoration: "underline", fontWeight: 700 }}
            >
              política de cookies
            </MuiLink>
            .
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25}>
            <Button variant="contained" color="secondary" onClick={acceptAll}>
              Aceptar todas
            </Button>
            <Button
              variant="contained"
              onClick={rejectAll}
              sx={{ color: "#fff", bgcolor: "#4A4A50", "&:hover": { bgcolor: "#626269" } }}
            >
              Rechazar todas
            </Button>
            <Button
              variant="text"
              onClick={openSettings}
              sx={{ color: "#fff" }}
            >
              Configurar
            </Button>
          </Stack>
        </Box>
      )}

      <Dialog
        open={settingsOpen}
        onClose={closeSettings}
        aria-labelledby="cookie-settings-title"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            bgcolor: "#17171A",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.16)",
          },
        }}
      >
        <DialogTitle id="cookie-settings-title" sx={{ color: "#fff" }}>
          Configuración de privacidad
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: "rgba(255,255,255,0.14)" }}>
          <Stack spacing={2.5}>
            <Box>
              <FormControlLabel
                control={<Switch checked disabled color="secondary" />}
                label="Necesarias (siempre activas)"
              />
              <Typography variant="body2" sx={{ color: "#B7B7BE" }}>
                Guardan tu elección y permiten el funcionamiento básico de la web.
              </Typography>
            </Box>
            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={draft.analytics}
                    color="secondary"
                    onChange={(event) =>
                      setDraft((current) => ({
                        ...current,
                        analytics: event.target.checked,
                      }))
                    }
                  />
                }
                label="Analíticas"
              />
              <Typography variant="body2" sx={{ color: "#B7B7BE" }}>
                Permiten cargar Google Analytics 4 para obtener estadísticas de uso.
              </Typography>
            </Box>
            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={draft.externalMedia}
                    color="secondary"
                    onChange={(event) =>
                      setDraft((current) => ({
                        ...current,
                        externalMedia: event.target.checked,
                      }))
                    }
                  />
                }
                label="Contenido externo"
              />
              <Typography variant="body2" sx={{ color: "#B7B7BE" }}>
                Permite cargar los mapas insertados de Google Maps.
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2, flexWrap: "wrap" }}>
          <Button onClick={rejectAll} variant="contained" sx={{ bgcolor: "#4A4A50" }}>
            Rechazar todas
          </Button>
          <Button onClick={saveDraft} variant="contained" color="secondary">
            Guardar selección
          </Button>
          <Button onClick={acceptAll} variant="contained" color="secondary">
            Aceptar todas
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CookieConsent;
